<script setup lang="ts">
defineOptions({
	name: 'WhoOwnsSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:person-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Who owns the cookies?') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>{{ $t('With regard to their origin, cookies can be classified as follows') }}:</p>
			<ul class="list-disc pl-7 space-y-2.5">
				<li>{{ $t('First-party cookies: These cookies are managed and stored by Gaveta Decimal') }}.</li>
			</ul>

			<p>{{ $t('We use the following first-party cookies') }}: <span class="font-semibold">Luckywise360.com</span></p>
			<ul class="list-disc pl-7 space-y-2.5">
				<li>
					{{
						$t(
							'Third-party cookies: These cookies are managed and stored by entities that have content or systems integrated into the Platform',
						)
					}}.
				</li>
			</ul>
			<p>{{ $t('We use the following third-party cookies') }}:</p>
			<p>
				{{ $t('For further information regarding the origin of each cookie, please consult the following link') }}:
				<NuxtLink
					to="https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d"
					target="_blank"
					class="underline text-sky-700"
				>
					Internet Explorer</NuxtLink
				>,
				<NuxtLink
					to="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&redirectlocale=en-US"
					target="_blank"
					class="underline text-sky-700"
				>
					Firefox</NuxtLink
				>,
				<NuxtLink
					to="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en"
					target="_blank"
					class="underline text-sky-700"
				>
					Google Chrome</NuxtLink
				>,
				<NuxtLink
					to="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
					target="_blank"
					class="underline text-sky-700"
				>
					Safari</NuxtLink
				>.
			</p>
		</div>
	</section>
</template>
